import { render, staticRenderFns } from "./DatatableV1RowAddEditModal.vue?vue&type=template&id=4c854bdb&"
import script from "./DatatableV1RowAddEditModal.vue?vue&type=script&lang=js&"
export * from "./DatatableV1RowAddEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../Breeze.Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports